import { Tag } from 'antd';

interface StateTagProps {
    state: string;
    currentState?: string;
    showDescription?: boolean;
}

const styles = {
    container: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: '8px',
    },
    tagContainer: {
        width: '80px',
        flexShrink: 0,
    },
    stateTag: {
        margin: 0,
        height: '22px',
        lineHeight: '22px',
        width: '100%',
        textAlign: 'center' as const,
    },
    stateDescription: {
        color: '#666',
        wordBreak: 'break-word' as const,
        lineHeight: '1.5',
        flex: 1,
    },
    stateDescriptionWithHighlight: {
        backgroundColor: 'transparent',
        padding: '0',
        borderRadius: '4px',
    }
};

const stateConfig = {
    locked: {
        color: 'red',
        description: 'Criteria to start the match hasn\'t been met (e.g. One or both of the participant(s) is still TBD from their previous match)',
        highlightColor: 'rgba(255, 77, 79, 0.1)'
    },
    wait: {
        color: 'blue',
        description: 'Criteria to start the match is met. Waiting to start the match.',
        highlightColor: 'rgba(24, 144, 255, 0.1)'
    },
    in_game: {
        color: 'green',
        description: 'The match is ongoing.',
        highlightColor: 'rgba(82, 196, 26, 0.1)'
    },
    finish: {
        color: 'purple',
        description: 'The match has ended and a winner has been determined automatically or by manual ruling.',
        highlightColor: 'rgba(114, 46, 209, 0.1)'
    },
    walkover: {
        color: 'orange',
        description: 'The match didn\'t start due to a participant failing to report on time or by manual ruling.',
        highlightColor: 'rgba(250, 140, 22, 0.1)'
    },
    bye: {
        color: 'cyan',
        description: 'This is a bye round in the tournament.',
        highlightColor: 'rgba(19, 194, 194, 0.1)'
    }
};

const StateTag: React.FC<StateTagProps> = ({ state, currentState, showDescription = false }) => {
    const config = stateConfig[state as keyof typeof stateConfig];
    if (!config) return null;

    const isHighlighted = currentState === state;

    return (
        <div style={styles.container}>
            <div style={styles.tagContainer}>
                <Tag color={config.color} style={styles.stateTag}>
                    {state.charAt(0).toUpperCase() + state.slice(1).replace('_', ' ')}
                </Tag>
            </div>
            {showDescription && (
                <span style={{
                    ...styles.stateDescription,
                    ...styles.stateDescriptionWithHighlight,
                    ...(isHighlighted && {
                        backgroundColor: config.highlightColor,
                        padding: '4px 8px'
                    })
                }}>
                    {config.description}
                </span>
            )}
        </div>
    );
};

export default StateTag;